import React from "react";

import { Button, Field, Input, makeStyles } from "@fluentui/react-components";

import { translate } from "@/utils/translations";

interface LoginFormProps {
  formData: {
    email: string;
    password: string;
    web: string;
  };
  generalError: string;
  isLoading: boolean;
  getFieldError: (field: string) => string | undefined;
  onInputChange: (
    field: keyof LoginFormProps["formData"],
    value: string
  ) => void;
  onSubmit: (e: React.FormEvent) => void;
}

export function LoginForm({
  formData,
  generalError,
  getFieldError,
  isLoading,
  onInputChange,
  onSubmit,
}: LoginFormProps) {
  const styles = useStyles();

  return (
    <form onSubmit={onSubmit}>
      <Field
        className={styles.field}
        label="Website"
        validationMessage={getFieldError("web")}
        validationState={getFieldError("web") ? "error" : "none"}
      >
        <Input
          onChange={(e) => onInputChange("web", e.target.value)}
          placeholder="https://company.app.cequence.io"
          value={formData.web}
        />
      </Field>

      <Field
        className={styles.field}
        label="Email"
        validationMessage={getFieldError("email")}
        validationState={getFieldError("email") ? "error" : "none"}
      >
        <Input
          onChange={(e) => onInputChange("email", e.target.value)}
          placeholder="your@email.com"
          type="email"
          value={formData.email}
        />
      </Field>

      <Field
        className={styles.field}
        label="Password"
        validationMessage={getFieldError("password")}
        validationState={getFieldError("password") ? "error" : "none"}
      >
        <Input
          onChange={(e) => onInputChange("password", e.target.value)}
          placeholder="Enter your password"
          type="password"
          value={formData.password}
        />
      </Field>

      {generalError && (
        <div className={styles.errorMessage}>{generalError}</div>
      )}

      <div className={styles.helpText}>
        {translate(
          "If you forgot password or you need account, please contact your IT department or sales@cequence.io"
        )}
      </div>

      <Button
        appearance="primary"
        className={styles.submitButton}
        disabled={isLoading}
        type="submit"
      >
        {translate(isLoading ? "Signing in..." : "Sign In")}
      </Button>
    </form>
  );
}

const useStyles = makeStyles({
  errorMessage: {
    backgroundColor: "#fdf2f2",
    border: "1px solid #f5c6cb",
    borderRadius: "4px",
    color: "#d13438",
    fontSize: "14px",
    marginTop: "16px",
    padding: "12px",
    textAlign: "center",
  },
  field: {
    marginBottom: "24px",
  },
  helpText: {
    color: "#0078d4",
    fontSize: "14px",
    marginTop: "16px",
    textAlign: "center",
  },
  submitButton: {
    marginTop: "8px",
    width: "100%",
  },
});
